import React from 'react';
import { View, Text } from 'react-native';
import { Button, Icon } from 'LocalGluons/index';
import { func, string } from 'prop-types';
import { t } from 'Locale/index';

import defaultStyles from './SuccessPage.jss';

const SuccessPage = ({ onContinue, message, buttonTitle }) => (
    <View style={defaultStyles.container}>
        <Icon name="success" style={defaultStyles.successIcon} />
        <Text style={[defaultStyles.title, { marginBottom: 50 }]}>{message}</Text>
        {onContinue && (
            <View style={defaultStyles.buttonWidth}>
                <Button
                    style={defaultStyles.button}
                    title={buttonTitle || t('COMMON.CONTINUE')}
                    onPress={onContinue}
                />
            </View>
        )}
    </View>
);

SuccessPage.defaultProps = {
    buttonTitle: null,
    onContinue: undefined
};

SuccessPage.propTypes = {
    message: string.isRequired,
    onContinue: func,
    buttonTitle: string
};

export default SuccessPage;
